/* eslint-disable no-irregular-whitespace */
import styled, { css } from 'styled-components';
import { themeable } from 'themes/utils';
import { numberToPx } from 'utils/css';
import { isColumnOptions, getColumnKey } from './utils';
import { ColumnOptions } from './Table.types';
import { Link } from 'react-router-dom';
import { checkboxMixin } from 'ui/Select/Select.styled';

export const Wrapper = styled.div`
    width: 100%;
`;

// Styled контейнер для всего списка
export const Container = styled.table<{
    $columns?: Record<string, ColumnOptions | string | undefined>;
    $paddingTop?: boolean;
    $disableScroll?: boolean;
}>`
    max-height: 100%;
    ${({ $disableScroll }) =>
        !$disableScroll &&
        css`
            overflow-y: auto;
            overflow-x: hidden;
        `}
    width: max-content;
    min-width: 100%;
    flex: 1;
    display: block;
    box-sizing: border-box;
    padding-bottom: 24px;

    ${({ $paddingTop }) =>
        $paddingTop &&
        css`
            padding-top: 24px;
        `}

    ${({ $columns }) =>
        $columns &&
        Object.keys($columns).map((key) => {
            const options = $columns[key];
            if (isColumnOptions(options)) {
                const columnKey = getColumnKey(key);

                return css`
                    & .td-${columnKey}, & .th-${columnKey} {
                        ${options.width &&
                        css`
                            width: ${numberToPx(options.width)};
                            flex: unset;
                        `}
                    }
                `;
            }
        })}

    &::-webkit-scrollbar {
        width: 3px; /* Убираем ширину скроллбара */
    }
`;

export const Body = styled.tbody`
    width: 100%;
    display: block;
`;

export const RowLink = styled(Link)`
    flex: 1;
`;

// Styled элемент списка
export const Row = styled.tr<{ $hasLink?: boolean; $editMode?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: ${themeable('secondaryBackground')};
    border-radius: 8px;
    min-width: 200px;
    min-height: 90px;
    box-sizing: border-box;
    flex: 1;

    ${({ $hasLink, $editMode }) =>
        ($hasLink || $editMode) &&
        css`
            cursor: pointer;
        `}
`;

// Styled контейнер для столбцов
export const Cell = styled.td`
    display: block;
    flex: 1;
    text-align: center; /* Выравнивание текста по центру */
    min-width: 100px;
    text-overflow: ellipsis;
    overflow: hidden;
    padding: 16px;
`;

// Styled контейнер для заголовков
export const Head = styled.thead`
    display: block;
    margin: 0 0 20px;
    position: sticky;
    top: 0;
`;

export const BeforeHeaderCell = styled.th`
    width: 100%;
`;

export const HeadRow = styled.tr`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 8px;
    min-width: 200px;
    box-sizing: border-box;
`;

// Styled элемент заголовка колонки
export const HeadingCell = styled.th`
    font-weight: bold;
    color: ${themeable('textColor')};
    padding: 0 8px;
    flex: 1;
    min-width: 100px;
    text-align: center;
    display: block;
`;

export const HeadingCellContent = styled.div`
    background: ${themeable('tableHeadingCellBackground')};
    width: max-content;
    display: block;
    margin: auto;
    padding: 6px 12px;
    border-radius: 4px;
`;

export const photoCellMixin = css`
    min-width: unset;
    width: 60px;
`;

export const NoRowsContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 30px 50px 50px;
    font-weight: 500;
    opacity: 0.7;
`;

export const RowContainer = styled.div`
    display: flex;
    flex-flow: row;
    align-items: stretch;
    width: 100%;

    margin-top: 16px;
    gap: 12px;

    & > a {
        width: 100%;
    }
`;

export const Checkbox = styled.div<SActiveProps>`
    height: 16px;
    ${checkboxMixin}
`;

export const CheckboxContainer = styled(Cell)`
    width: 16px;
    height: auto;
    flex: none;
    min-width: unset;
`;

export const CellListValue = styled.span`
    white-space: nowrap;
    display: inline-block;

    &:not(:last-child)::after {
        content: ', ';
    }
`;

export const CellListSeparator = styled.span`
    &:last-child {
        display: none;
    }
`;
